import { Button, useTheme } from '@mui/material'
import React from 'react'

export const PrimaryButton = ({ children, disabled = false, ...rest }) => {
  const theme = useTheme()
  return (
    <Button
      {...rest}
      variant='contained'
      color='primary'
      disableElevation
      style={{
        backgroundColor: disabled
          ? theme.palette.grey[400]
          : theme.palette.sunrise6.main,
        minWidth: 150,
        paddingRight: 16,
        paddingLeft: 16,
        height: 38,
        lineHeight: '38px'
      }}
      disabled={disabled}
    >
      {children}
    </Button>
  )
}
